import {
  REQUEST_TRIP_DETAILS,
  RECEIVE_TRIP_DETAILS,
  RECEIVE_TRIP_DETAILS_FAILURE,
  CLEAR_TRIP_DETAILS_ERROR,
  TOGGLE_SELECT_BYOR,
  RESET_SELECT_BYOR
} from '../constants/actionTypes';

const INITIAL_STATE = {
  currentTrip: {},
  loading: true,
  error: null,
  isByAge: false,
  pax: {},
  byorSelected: true,
  isRaptor: false
};

function tripDetailsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_TRIP_DETAILS: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_TRIP_DETAILS: {
      return {
        ...state,
        currentTrip: action.response,
        loading: false,
        isByAge: action.response.trip_price.price_type === 'by_age',
        isByPax: action.response.trip_price.price_type === 'by_pax',
        isRaptor: (action.response.title =="Ford Ranger Raptor Sepang Experience" ? true : false),
        pax: action.response.pax
      };
    }
    case RECEIVE_TRIP_DETAILS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    case CLEAR_TRIP_DETAILS_ERROR: {
      return {
        ...state,
        error: null
      };
    }
    case TOGGLE_SELECT_BYOR: {
      return {
        ...state,
        byorSelected: !state.byorSelected
      };
    }
    case RESET_SELECT_BYOR: {
      return {
        ...state,
        byorSelected: false
      };
    }

    default:
      return state;
  }
}

export default tripDetailsReducer;
